import { SecondaryButton } from '@rsa-digital/evo-shared-components/components/Button';
import { Grid, GridItem } from '@rsa-digital/evo-shared-components/components/Grid';
import Icon from '@rsa-digital/evo-shared-components/components/Icon';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const StyledIcon = styled(Icon)`
  display: flex;

  margin-left: ${spacing(2)};

  ${mediaQuery.tabletPortrait`
    margin-left: ${spacing(3)};
  `}
`;

export const StyledSubmitButton = styled(SecondaryButton)`
  width: 100%;

  ${mediaQuery.tabletPortrait`
    width: auto;
  `}
`;

export const GridWithMargins = styled(Grid)`
  && {
    margin-top: ${spacing(2)};
  }
`;

export const BodyTextGrid = styled(Grid)`
  && {
    margin-top: ${spacing(2)};

    ${mediaQuery.tabletPortrait`
      margin-top: ${spacing(3)};
    `}
  }
`;

export const StyledForm = styled.form`
  margin-top: ${spacing(2)};

  ${mediaQuery.tabletLandscape`
    margin-top: ${spacing(6)};
  `}
`;

export const SubmitButtonGridItem = styled(GridItem)`
  display: flex;
  justify-content: center;
`;
